module.exports = __webpack_public_path__ + "a9c2a19f853b3f9c92534611fd2c7353.svg";